import React, { useState, useEffect } from "react";
import { useParams, useLocation, Link } from "react-router-dom";
import Layout from "@/components/Layout";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import BetList from "../bet-list";
import ActivityTab from "./ActivityTab";
import BalanceTab from "./BalanceTab";
import styles from "./ActivityReport.module.css";
import BetListInUser from "./BetListInUser";
import BettingPL from "./BettingPl";
import AccountStatementDetails from "./AccountStatementDetails";
import TransferStatementDetails from "./TransferDetails";
import NetExposureDetails from "./NetExposureDetails";
import CleintStateMentDetails from "./CleintStateMentDetails";

const PlaceholderTab = ({ title }) => (
  <div className="bg-[#171b36] p-4 text-white">
    <h3 className="text-xl">{title}</h3>
    <p className="opacity-70 mt-2">Content for {title} goes here.</p>
  </div>
);

export default function UserDetails() {
  const { id } = useParams();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState("Activity");

  // You might want to fetch user details here using `id`
  // For now, we use the ID in the breadcrumb
  const [username, setUsername] = useState("Loading...");
  const [userType, setUserType] = useState(null);

  useEffect(() => {
    // Simulation of fetching user details
    // In real app, fetch user by ID
    if (id) {
      setUsername(`User #${id}`);
      // If you passed state via navigate, you could use it: location.state?.username
      if (location.state?.username) {
        setUsername(location.state.username);
      }
      if (location.state?.type) {
        setUserType(location.state.type);
      } else if (location.state?.role) {
        // Normalize role
        const r = location.state.role.toUpperCase();
        if (r === 'USER') setUserType('USER');
        else setUserType('STAFF'); // or keep as is
      }
    }
  }, [id, location.state]);

  const tabs = [
    { name: "Activity", component: <ActivityTab /> },
    { name: "Balance", component: <BalanceTab /> },
    {
      name: "Betlist",
      component: <BetListInUser
        embedded={true}
        isPadding={false}
        userId={userType === 'USER' ? id : undefined}
        staffId={userType !== 'USER' ? id : undefined}
      />
    },
    { name: "Betting P&L", component: <BettingPL /> },
    { name: "Statement", component: <AccountStatementDetails /> },
    { name: "Transfer Statement", component: <TransferStatementDetails username={username} /> },
    { name: "Net Exposure", component: <NetExposureDetails /> },
    { name: "Clients Account Statement", component: <CleintStateMentDetails /> },
  ];

  return (
    <Layout>
      <div className="p-4 w-full mx-auto bg-[#171b36] h-auto">
        <div style={{ backgroundColor: "rgba(0, 0, 0, 0.4)" }}
          className="shadow-sm px-4 py-4">
          {/* Breadcrumb / Header */}
          <div className="text-[#3cd247] text-sm mb-2 font-semibold">
            <Link to="/agent-listing" className={`hover:underline !text-[#17a2b8] ${styles.fontItalic}`}>Downline Listing</Link>
            <span className="mx-2 text-white">&gt;</span>
            <span className="text-white">{username}</span>
          </div>

          {/* Tabs Header */}
          <div className="flex flex-wrap overflow-hidden">
            {tabs.map((tab, index) => (
              <button
                key={tab.name}
                onClick={() => setActiveTab(tab.name)}
                className={`px-4 py-2 text-sm font-medium transition-all duration-200 text-white${activeTab === tab.name
                    ? "text-white"
                    : "text-gray-300 hover:text-white hover:bg-gray-700"
                  } whitespace-nowrap`}
                style={{
                  backgroundColor: activeTab === tab.name ? '#333d79ff' : '#666',
                  // borderTop: '1px solid #4a5568',
                  color: 'white',
                  // borderLeft: index === 0 ? '1px solid #4a5568' : 'none',
                  // borderBottom: activeTab === tab.name ? 'none' : '1px solid #4a5568',
                }}
              >
                {tab.name}
              </button>
            ))}
          </div>

          {/* Tab Content */}
          <div className=" bg-[#171b36]">
            {tabs.find((t) => t.name === activeTab)?.component}
          </div>
        </div>
      </div>
    </Layout>
  );
}
